import { FC } from "react"
import { VisionPage as VisionPageContent } from "../../../components/LandingPage/VisionPage"

export const LandingVisionPage: FC = () => {
  return <VisionPageContent />
}
